//DBTables
import { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useGlobalData } from "../GlobalDataProvider";
import ModuleConfiguratorForm from "./ModuleConfiguratorForm";

const ModuleConfigurator = () => {
  const { buildingId, moduleId } = useParams();
  const navigate = useNavigate();
  const globalData = useGlobalData();

  const didRedirect = useRef(false);

  const building = buildingId ? globalData.buildings?.find((b) => b.id === parseInt(buildingId)) : undefined;
  if (!building) return <>Not found</>;

  const module = moduleId ? building.modules.find((m) => m.id === parseInt(moduleId)) : undefined;
  if (!module) return <>Not found</>;

  const cancelConfiguration = () => {
    if (didRedirect.current) return;
    didRedirect.current = true;
    navigate(-1);
  };

  return (
    <>
      <ModuleConfiguratorForm building={building} module={module} cancelConfiguration={cancelConfiguration}></ModuleConfiguratorForm>
    </>
  );
};

export default ModuleConfigurator;
